import { render, staticRenderFns } from "./venueadd.vue?vue&type=template&id=da5c0ef2&scoped=true&"
import script from "./venueadd.vue?vue&type=script&lang=js&"
export * from "./venueadd.vue?vue&type=script&lang=js&"
import style0 from "./venueadd.vue?vue&type=style&index=0&id=da5c0ef2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5c0ef2",
  null
  
)

component.options.__file = "venueadd.vue"
export default component.exports